import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const Operations = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content">
          <div className="container px-0">
            <div className="accordion mt-3" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseOne"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseOne"
                  >
                    <div className="col d-flex align-items-center">
                      <h4 className="event-alert p-0 mb-0">Liquidity </h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingOne"
                >
                  <div className="row mx-0">
                    <div className="container px-0">
                      <div className="row">
                        <div class="col-md-12 inventory_summary_master liquidity">
                          <div class="shadowclass my-2">
                            <div class="col-12 m-0">
                              <ul class="comparison_listing liquidity-sec">
                                <li>
                                  <h4>
                                    0.0
                                    <span class="desc">
                                      <img src="/img/not.png" alt="" />
                                      Unhealthy companies have lower than 2.0
                                    </span>
                                  </h4>
                                  <p>
                                    Current Ratio <br />
                                    (Cur. Assets / Cur. Liab.)
                                  </p>
                                </li>
                                <li>
                                  <h4>
                                    0.0{" "}
                                    <span class="desc">
                                      <img src="/img/not.png" alt="" />{" "}
                                      Unhealthy companies have lower than 1.0
                                    </span>
                                  </h4>
                                  <p>
                                    Quick Ratio <br />
                                    (Cur. Assets - Inv. / Cur. Liab.)
                                  </p>
                                </li>
                                <li>
                                  <h4>
                                    0.0{" "}
                                    <span class="desc">
                                      <img src="/img/not.png" alt="" />{" "}
                                      Unhealthy companies have lower than 1.0
                                    </span>
                                  </h4>
                                  <p>
                                    Working Capital Ratio
                                    <br />
                                    (Total Assets / Total Liab.)
                                  </p>
                                </li>
                                <li>
                                  <h4>
                                    0.0{" "}
                                    <span class="desc">
                                      <img src="/img/yes.png" alt="" /> Healthy
                                      companies have 0.75 or lower
                                    </span>
                                  </h4>
                                  <p>
                                    Debt-to-Equity Ratio
                                    <br />
                                    (Total Debt / Total Equity)
                                  </p>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseOne"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseOne"
                  >
                    <div className="col d-flex align-items-center">
                      <h4 className="event-alert p-0 mb-0">Red flags </h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingOne"
                >
                  <div className="row mx-0">
                    <div className="container px-0">
                      <div className="row">
                        <div class="col-md-12">
                          <div className="shadowclass mt-2">
                            <div class="inventory_summary_master">
                              <div class="row-fluid">
                                <div class="col-12">
                                  <div class="counts date_new_Cont">
                                    <h4 class="event-alert">
                                      Select Your Period
                                    </h4>

                                    <div class="half_new_div d-flex">
                                      <a href="#_" class="date_label">
                                        <i class="iconSprites arrow-left"></i>
                                      </a>
                                      <span class="date-text">
                                        May 1, 2022 - May 12, 2022
                                      </span>
                                      <span class="clander_icon"></span>
                                    </div>

                                    <div class="half_right_div">
                                      <ul class="summary_filter add">
                                        <li class="">
                                          <a href="/finance_summary/general/timeLimit:day">
                                            Day
                                          </a>
                                        </li>
                                        <li class="">
                                          <a href="/finance_summary/general/timeLimit:week">
                                            Week
                                          </a>
                                        </li>
                                        <li class="active">
                                          <a href="/finance_summary/general/timeLimit:month">
                                            Month
                                          </a>
                                        </li>
                                        <li class="">
                                          <a href="/finance_summary/general/timeLimit:quarter">
                                            Quarter
                                          </a>
                                        </li>
                                        <li class="">
                                          <a href="/finance_summary/general/timeLimit:year">
                                            Year
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="shadowclass mt-3">
                            <div class="col-12">
                              <div class="select-comparison">
                                <label class="key">Key Statistics Vs.</label>
                                <div class="select-div widthextra">
                                  <select
                                    name="data[comparison]"
                                    class="comparison"
                                    id="comparison"
                                  >
                                    <option value="">Select Comparison</option>
                                    <option value="0" selected="selected">
                                      Previous Period
                                    </option>
                                    <option value="1">
                                      Same Period Previous Year
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div class="col-12 m-0">
                              <ul class="comparison_listing statistics_data">
                                <li>
                                  <h4>0%</h4>
                                  <p>Net Sales / Gross Sales Ratio</p>
                                </li>
                                <li>
                                  <h4>0%</h4>
                                  <p>Cash As % Of Sales</p>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Operations;
